module.exports = __webpack_public_path__ + "img/macao.e7460625.png";